import { atom } from "jotai"

export const dismissedGiveawaysAtom = atom<Set<number>>(new Set<number>())
